<template>
  <div>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <div class="mt-3">
                <v-row class="match-height">
                  <v-col
                    cols="12"
                    v-if="checkIfSupport || showUnitForecastForEvents"
                  >
                    <v-skeleton-loader
                      v-if="helpers.dataIsLoading"
                      elevation="2"
                      type="article"
                    ></v-skeleton-loader>
                    <v-card v-else>
                      <v-card-title class="body-2 v-card__subtitle">
                        <v-icon x-small class="mr-2">mdi-fire-truck</v-icon
                        >Besetzbarkeit von Einsatzmittel
                        <v-spacer></v-spacer>
                        <v-btn-toggle
                          v-model="analysisMode"
                          mandatory
                          class="mr-4"
                          dense
                        >
                          <v-btn small value="best-effort">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-chart-timeline-variant-shimmer</v-icon
                            >
                            <span class="hidden-sm-and-down">Best-Effort</span>
                          </v-btn>
                          <v-btn small value="scenarios">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-chart-multiple</v-icon
                            >
                            <span class="hidden-sm-and-down">Szenarien</span>
                          </v-btn>
                          <v-btn small value="all-units">
                            <v-icon :left="!$vuetify.breakpoint.smAndDown" small
                              >mdi-vector-circle-variant</v-icon
                            >
                            <span class="hidden-sm-and-down">Alle einzeln</span>
                          </v-btn>
                        </v-btn-toggle>
                      </v-card-title>
                      <event-unit-forecast-card-content
                        v-if="event.units"
                        :requestedUnits="event.units"
                        :availablePersonnel="eventResponsesMatched"
                        :forecastMode="analysisMode"
                      >
                      </event-unit-forecast-card-content>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import EventUnitForecastCardContent from "@/components/scheduling/EventUnitForecastCardContent.vue";
import { ADMIN } from "@/store/modules.js";
import { GET_USER_LIST } from "@/store/action-types.js";

export default {
  name: "event-details-tab-staffing",
  components: {
    EventUnitForecastCardContent,
  },
  props: {
    event: Object,
  },
  data() {
    return {
      data: { meta: { status: "" } },
      helpers: {
        dataIsLoading: true,
      },
      eventResponses: [],
      analysisMode: "best-effort",
    };
  },
  computed: {
    showUnitForecastForEvents() {
      return this.$store.getters["organization/checkFeatureAvailabilityById"](
        "showUnitForecastForEvents"
      );
    },
    memberships() {
      return this.$store.state.admin.membershipsPublic;
    },
    membershipsPrepared() {
      var range = {
        start: this.event.duration.start.timestampToDate,
        end: this.event.duration.end.timestampToDate,
      };
      var membershipsFiltered = this.memberships.filter((obj) => {
        return (
          new Date(obj.user.memberSinceToDate) <= new Date(range.start) &&
          !(new Date(obj.user.memberUntilToDate) <= new Date(range.end)) &&
          obj.access.type === "member"
        );
      });

      var memberships = membershipsFiltered;
      const result = memberships.map((item) => {
        const container = {
          groupByGroup:
            item.group.sortKey.toString().padStart(4, "0") +
            "_" +
            item.group.title,
          groupByDivision:
            item.user.division.sortKey.toString().padStart(4, "0") +
            "_" +
            item.user.division.title,
          group: {
            title: item.group.title,
            sortKey: item.group.sortKey,
            id: item.group.id,
          },
          user: {
            displayName: item.user.displayName,
            uid: item.user.uid,
            division: {
              title: item.user.division.title,
              shortTitle: item.user.division.shortTitle,
              sortKey: item.user.division.sortKey,
              id: item.user.division.id,
            },
            fillablePositions: item.fillablePositions,
            relevantSkills: item.relevantSkills,
          },
        };
        return container;
      });
      return result;
    },
    eventResponsesMatched() {
      const memberships = this.membershipsPrepared;
      const matched = this.eventResponses
        .map((response) => {
          const matchedMembership = memberships.find(
            (membership) => membership.user.uid === response.meta.uid
          );
          if (matchedMembership) {
            return { ...response, ...matchedMembership };
          }
          return null;
        })
        .filter((item) => item !== null);

      const missing = memberships.filter((o) =>
        matched.every((s) => s.user.uid !== o.user.uid)
      );

      var addedStatus = [];
      if (missing.length > 0) {
        addedStatus = missing.map((obj) => ({
          ...obj,
          comment: "",
          type: "regular",
          isCanceled: false,
          meta: {
            uid: obj.user.uid,
            lastUpdatedBy: "",
          },
          groupByStatus: "5_Keine Rückmeldung",
          status: {
            id: "0",
          },
          assignedTasks: [],
          assignedPosition: {
            custom: {
              text: "",
            },
            unit: {
              id: "",
              title: "",
            },
            position: {
              id: "",
              shortTitle: "",
            },
            comboId: "",
          },
          guests: {
            count: 0,
          },
        }));
      }

      let output = matched.concat(addedStatus);

      if (this.event.config.attendance.isLimited) {
        const allowedAttendeesIds =
          this.event.config.attendance.allowedAttendeesIds;
        output = output.filter((obj) => {
          return (
            allowedAttendeesIds.includes(obj.user.uid) ||
            allowedAttendeesIds.includes(obj.group.id) ||
            allowedAttendeesIds.includes(obj.user.division.id) ||
            obj.status.id !== "0"
          );
        });
      }

      return output;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
    event: function (newValue) {
      this.data = newValue;
      if (newValue !== null) {
        this.getMemberships();
      }
    },
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("events")
        .doc(this.$route.params.itemId)
        .collection("responses")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              ...doc.data(),
              groupByStatus:
                this.orderPrefix(doc.data().status.id) +
                "_" +
                this.statusText(doc.data().status.id),
              status: {
                id: doc.data().status.id,
              },
              meta: {
                uid: doc.data().meta.uid,
                lastUpdatedAt: doc.data().meta.lastUpdatedAt,
                lastUpdatedBy: doc.data().meta.lastUpdatedBy,
              },
            };
            this.eventResponses.push(data);
          });
        })
        .then(() => {
          this.helpers.dataIsLoading = false;
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    getMemberships() {
      if (this.data.status === "planned") {
        this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
          organizationId: this.$route.params.organizationId,
          queryIsFiltered: true,
          query: {
            type: "active",
          },
        });
      } else {
        this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
          organizationId: this.$route.params.organizationId,
          queryIsFiltered: false,
          query: {
            type: "archived",
            memberUntil: this.convertToDate(
              this.event.duration.start.timestamp
            ),
          },
        });
      }
    },
    statusText(item) {
      switch (item) {
        case "-1":
          return "Nicht eingeladen";
        case "0":
          return "Keine Rückmeldung";
        case "1":
          return "Verfügbar";
        case "2":
          return "Nicht verfügbar";
        case "3":
          return "Wenn notwendig";
        case "4":
          return "Nicht in Stadt";
        case "":
          return "Fehler";
        default:
          return "";
      }
    },
    orderPrefix(item) {
      switch (item) {
        case "-1":
          return "7";
        case "0":
          return "5";
        case "1":
          return "1";
        case "3":
          return "2";
        case "2":
          return "3";
        case "4":
          return "4";
        case "X":
          return "X";
        default:
          return "";
      }
    },
    convertToDate(date) {
      date = date.toDate();
      return (
        (date.getDate() < 10 ? "0" : "") +
        date.getDate() +
        "-" +
        (date.getMonth() + 1 < 10 ? "0" : "") +
        (date.getMonth() + 1) +
        "-" +
        date.getFullYear()
      );
    },
  },
};
</script>
